module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_1.2aac9590.png";